<template>
  <input
    ref="input"
    type="number"
    min="0"
    max="9"
    :disabled="disabled"
    maxlength="1"
    pattern="[0-9]"
    v-model="model"
    @input="handleOnChange"
    @keydown="handleOnKeyDown"
    @paste="handleOnPaste"
    @focus="handleOnFocus"
    @blur="handleOnBlur"
    :class="{ active: focus }"
  >
</template>

<script>
export default {
  name: 'OtpInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    focus: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      model: this.value || '',
    };
  },
  mounted () {
    if (this.$refs.input && this.focus) {
      this.$refs.input.focus();
    }
  },
  watch: {
    value (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.model = newValue;
      }
    },
    focus (newFocusValue, oldFocusValue) {
      if (oldFocusValue !== newFocusValue && (this.$refs.input && this.focus)) {
        this.$refs.input.focus();
        this.$refs.input.select();
      }
    },
  },
  methods: {
    handleOnChange () {
      if (this.model.length > 1) {
        this.model = this.model.slice(0, 1);
      }
      return this.$emit('change', this.model);
    },
    handleOnKeyDown (event) {
      const keyEvent = event;
      const charCode = (event.which) ? event.which : event.keyCode;
      const isValidKey = this.isCodeNumeric(charCode) ||
        (charCode === 8) ||
        (charCode === 86) ||
        (charCode === 46);
      if (!isValidKey) {
        keyEvent.preventDefault();
      } else {
        this.$emit('keydown', event);
      }
    },
    isCodeNumeric (charCode) {
      return (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105);
    },
    handleOnPaste (event) {
      return this.$emit('paste', event);
    },
    handleOnFocus () {
      this.$refs.input.select();
      return this.$emit('focus');
    },
    handleOnBlur () {
      return this.$emit('blur');
    },
  },
};
</script>

<style lang="scss" scoped>
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
  div{
    display: flex;
    align-items: center;
    input{
      background-color: #f1f2f7;
      outline: none;
      border: none;
      width: 45px;
      height: 45px;
      border-radius: 6px;
      font-size: 30px;
      font-weight: 500;
      text-align: center;
      color: #273142;

      &.active {
        border: 1px solid var(--orange-500) !important;
      }

      &:disabled{
        cursor: not-allowed;
      }
    }
  }
</style>
